import { css } from '@emotion/react';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import t from 'react-translate';

import { AngularServicesContext } from 'react-app';
import { getCurrentCourse } from 'redux/selectors/course';
import useAngularExpression from 'shared/hooks/use-angular-expression';
import useCourseHomeUtils from 'shared/hooks/use-course-home-utils';

import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import NvTooltip from 'shared/components/nv-tooltip';
import { config } from '@config/pendo.config.json';

const styles = css`
  .icon-wrapper {
    padding-right: 0px !important;
  }
`;

const EditButton = () => {
  const {
    $state,
    CurrentPermissionsManager,
    TimelinesManager,
  } = useContext(AngularServicesContext);
  const currentStateName = useAngularExpression(() => $state.current.name);
  const isCourseHome = currentStateName === 'course-home'
    || currentStateName === 'course-home-edit'
    || currentStateName === 'program-home'
    || currentStateName === 'program-timelines-edit';

  const hasEditPermission = CurrentPermissionsManager.isCourseBuilder();

  const { catalogId, isProgram } = useSelector(getCurrentCourse);
  const { isWhiteIcon } = useCourseHomeUtils();

  const isEditOrReorderMode = TimelinesManager.isEditMode()
    || TimelinesManager.isReorderMode();

  const handleEditClick = () => {
    $state.go(
      isProgram ? 'program-timelines-edit' : 'course-home-edit',
      { catalogId },
    );
  };

  return (
    <React.Fragment>
      {isCourseHome && hasEditPermission && (
        <div css={styles}>
          <ClickableContainer
            className={`page-link ${isWhiteIcon ? 'text-white' : ''}`}
            onClick={handleEditClick}
            role='button'
            aria-label={t.COURSE_HOME.HEADER.EDIT_OUTLINE()}
            tabIndex={isEditOrReorderMode ? -1 : 0}
            data-qa={config.pendo.topNav.editOutline}
          >
            <div className='icon-wrapper d-flex align-items-center'>
              <NvTooltip
                text={t.COURSE_HOME.HEADER.EDIT_OUTLINE()}
                placement='bottom'
              >
                <NvIcon icon='edit' size='small' />
              </NvTooltip>
            </div>
          </ClickableContainer>
        </div>
      )}
    </React.Fragment>
  );
};

export default EditButton;
